export const ZUORA_KEY_REGEX = /^SUB\d{8,}$/i;
export const ZUORA_KEY_VALIDATION_MESSAGE = "Must start with 'SUB' followed by at least 8 digits";
